import { createStore, combineReducers } from 'redux';
import Info from './reducer/Info';
import InfoList from './reducer/InfoList';
import RankList from './reducer/RankList';
import User from './reducer/User';
import Payment from './reducer/Payment';
import Messages from './reducer/Messages';
import FavoriteChannels from './reducer/FavoriteChannels';
import RecentChannels from './reducer/RecentChannels';
import Tour from './reducer/Tour'


let reducer = combineReducers({ Info, InfoList, RankList, User, Payment, Messages, FavoriteChannels, RecentChannels, Tour });
const store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;


// WEBPACK FOOTER //
// ./src/store.js